<template>
    <div class="main_questions_nav_bar">
         <div class="publish_tags">
                <span>
                    发布至:
                </span>
                <span class="publish_tag"
                      @click="tab_active('交流讨论')"
                      :class="[tag=='交流讨论' ? 'publish_tag_active' : '']"
                >
                    {{all_nav_bar_tag[current_nav_bar_tag]}}
                </span>
            </div>
        <ul class="main_questions_nav_bar_ul">
            <div class="main_questions_nav_bar_div">
                <li class="main_questions_nav_bar_li"
                    v-for="(tag,query) in all_nav_bar_tag"
                    :key="tag"
                    @click="change_current_nav_bar_tag(query)"
                    :class="current_nav_bar_tag===query ? 'main_questions_nav_bar_active' : ''"
                >
                    {{ tag }}
                </li>
            </div>
        </ul>
    </div>
</template>
<script type="text/javascript">
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                all_nav_bar_tag: {"discussion": "交流讨论", "sharing": "技术分享"},
                current_nav_bar_tag: 'discussion'
            }
        },
        computed: {
            ...mapState({})
        },

        methods: {
            ...mapActions({}),
            change_current_nav_bar_tag(query) {
                this.current_nav_bar_tag = query
                this.$emit('type',query)
            }

        }
    }

</script>
<style type="text/css" scoped>
     .publish_tags {
         margin-bottom: 10px;
        /*color: #333;*/
        /*font-size: 14px;*/
        /*font-weight: 700;*/
        /*display: flex;*/
    }

    .publish_tag {
    }
    .main_questions_nav_bar_ul {
        display: flex;
        margin-bottom: 10px;
    }

    .main_questions_nav_bar_li {
        padding: 6px 16px;
        color: #999;
        font-size: 14px;
        cursor: pointer;
    }
    .main_questions_nav_bar_active {
    color: #6CF;
    background: #E7F8F2;
}

    .main_questions_nav_bar_div {
        display: flex;
    }

</style>
